import {Outlet} from "react-router";
import Providers from "../Providers/Proviers";
import React from "react";
import NavigationProgress from "../components/NavigationProgress";

export default function RootLayout() {
    return (
        <div className="font-YekanBakh min-h-screen bg-white text-gray-900">
            <Providers>
                <NavigationProgress/>
                <Outlet/>
            </Providers>
        </div>
    );
}
